<template>
  <!-- 订单管理 -->
  <div class="el-card  pd20">
    <!-- add---新增 -->
    <!-- <div class="box">

            <div class="search">

                <div class="search-gropu">
                    用户昵称
                    <el-input class="search-child" v-model="course_name" placeholder="请输入用户昵称"></el-input>
                </div>

                <el-button type="primary" @click="pullData" size="medium">搜索</el-button>
            </div>
        </div> -->
    <!--  -->
    <div class="el-card  pd20 content">
      <el-table :data="list" border style="width: 100%">
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column type="index" width="100" label="序号"></el-table-column>
        <el-table-column prop="name" label="课程名称"></el-table-column>
        <el-table-column prop="price" label="课程价格"> </el-table-column>
        <el-table-column label="推广佣金" width="260">
          <template slot-scope="scope">
            直接推广佣金：{{scope.row.rules[0].first_fee}} ~ {{scope.row.rules[1].first_fee}} 元
            <br/> 间接推广佣金：{{scope.row.rules[0].second_fee}} ~ {{scope.row.rules[1].second_fee}} 元
            <br/>
          </template>
        </el-table-column>
        <el-table-column prop="create_time" label="创建时间"></el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button type="primary" size="mini" icon="el-icon-edit" @click="edit(scope.row)" circle></el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <el-pagination class="pages" :page-sizes="[25, 50, 75, 100]" @size-change="handleSizeChange" @current-change="handleCurrentChange" :page-size="pages.size" :current-page="pages.page" background layout="sizes,prev, pager, next" :total="pages.count">
      </el-pagination>
    </div>
    <!-- 设置佣金 -->
    <el-dialog title="佣金设置" class="form-box" :visible.sync="set_commission">
      <el-table :data="form.rules" border style="width: 100%">
        <el-table-column label="推广员级别">
          <template slot-scope="scope">
            <el-input v-model="scope.row.role"></el-input>
          </template>
        </el-table-column>
        <el-table-column label="升级规则">
          <template slot-scope="scope">
            <div v-if="scope.row.level ==1 ">
              所有推广员默认等级
            </div>
            <div v-else>
                <el-checkbox v-model="promote_count_show" :disabled="scope.row.promote_count==''">
                  推广订单
                  <el-input v-model="scope.row.promote_count" class="widvs"></el-input> 笔
                </el-checkbox>
                <el-checkbox v-model="invite_count_show" :disabled="scope.row.invite_count==''">
                  邀请下级
                  <el-input v-model="scope.row.invite_count" class="widvs"></el-input> 人
                </el-checkbox>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="直接推广佣金比例">
          <template slot-scope="scope">
            <el-input v-model="scope.row.first_fee" class="widv"></el-input> 元
          </template>
        </el-table-column>
        <el-table-column label="间接推广佣金比例">
          <template slot-scope="scope">
            <el-input v-model="scope.row.second_fee" class="widv"></el-input> 元
          </template>
        </el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer">
        <el-button @click="set_commission = false">取 消</el-button>
        <el-button type="primary" @click="submitForm">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import {
  campFee,
  setRule,
  missionCamp
} from "@/api/operating";
export default {
  data() {
      return {
        pages: {},
        list: [],
        //
        course_name: '',
        form: {
          course_id: '',
          rules: []
        },
        set_commission: false,
        promote_count_show: false,
        invite_count_show: false
      }
    },
    methods: {
      // 提交数据
      submitForm() {
        if (!this.invite_count_show && !this.promote_count_show) {
          this.$message("请选择一项以上的升级规则！");
          return;
        }

        for (let arg of this.form.rules) {
          if (arg.invite_count != 0) {
            arg.invite_count = this.invite_count_show?arg.invite_count:0
          }
          if (arg.promote_count != 0) {
            arg.promote_count = this.promote_count_show?arg.promote_count:0
          }
        }

        setRule(this.form).then((data) => {
          if (data.error > 0) {
            this.$message(data.msg);
            return
          }
          this.set_commission = false;
          this.invite_count_show = false;
          this.promote_count_show = false;
          this.$notify({
            title: '成功',
            message: '添加成功',
            type: 'success'
          });
        });
      },
      // 点击修改图标触发函数
      edit(row) {
        this.form['course_id'] = row.id;
        this.form.rules = row.rules;
        this.set_commission = true;
        for (let arg of row.rules) {
          if (arg.invite_count !== 0) {
            this.invite_count_show = true
          }
          if (arg.promote_count !== 0) {
            this.promote_count_show = true
          }
        }

      },
      // 调整每页显示条数
      handleSizeChange(val) {
        this.pages.size = val;
        this.pullData();
      },
      // 触发分页
      handleCurrentChange(val) {
        this.pages.page = val;
        this.pullData();
      },
      pullData() {
        this.$showLoading();
        this.obj = {
          page: Object.keys(this.pages).length > 0 ? this.pages.page : 1, //页码，默认1
          size: Object.keys(this.pages).length > 0 ? this.pages.size : 25 //每页数量，默认25
        };
        // 判断如果有值为真的情况下传参,否则不传
        if (this.course_name) {
          this.obj['course_name'] = this.course_name;
        }
        let arr1 = campFee(this.obj);

        let arr2 = missionCamp();

        Promise.all([arr1, arr2]).then((data) => {
          this.list = data[0].list;
          this.pages = data[0].pager;

          //
          this.course_list = data[1].list;
          this.$hideLoading();
        }).catch((err) => {
          this.$hideLoading();
        });
      }
    },
    created() {
      this.pullData();
    }
}
</script>
<style lang="scss" scoped>
.headimgurl {
  width: 100px;
  height: 100px;
}

.box {
  margin-bottom: 20px;
}

.content {
  padding: 20px;
}

.pages {
  text-align: right;
  margin-top: 30px;
}

.search {
  display: flex;
  margin-bottom: 20px;
}

.search.search-btn {
  flex: 1;
}

.search-gropu {
  flex: 1;
}

.search-child {
  margin-left: 20px;
  width: 200px;
}
</style>
<style lang="scss">
.form-box .el-input {
  width: auto;
}

.form-box input {
  background-color: #fff !important;
  color: #333 !important;
}

.widv input {
  width: 120px;
}

.widvs input {
  width: 50px;
  line-height: 40px;
  margin-top: 20px;
  padding: 0 6px;
}

.el-dialog {
  background-color: #fff !important
}

.new-style .el-dialog .el-dialog__title {
  color: #303133 !important;
  font-weight: bold;
}
</style>
